var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero'),_c('hr'),_c('p',[_vm._v("Our apologies. Your form submission did not go through.")]),_c('router-link',{attrs:{"to":"/"}},[_c('button',[_vm._v("Return to home page.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }